import { useAuthStore } from '@/stores/authStore'

/**
 * Capability check for UI gating.
 *
 * COSMETIC ONLY. Every one of these is re-checked server-side by the `cap:`
 * middleware — hiding a button is a courtesy to the user, not a security
 * boundary. Never rely on this to protect anything.
 */
export function useCan(capability: string | string[]): boolean {
  return useAuthStore((s) => {
    const held = s.session?.capabilities
    if (!held) return false

    // The owner short-circuits everything, matching Gate::before on the server.
    if (s.session?.user.is_owner) return true

    const wanted = Array.isArray(capability) ? capability : [capability]
    return wanted.some((c) => held.includes(c))
  })
}

/** True only if the user holds ALL of them. */
export function useCanAll(capabilities: string[]): boolean {
  return useAuthStore((s) => {
    const held = s.session?.capabilities
    if (!held) return false
    if (s.session?.user.is_owner) return true
    return capabilities.every((c) => held.includes(c))
  })
}

/** Plan feature check — "does this workspace's plan include it?" */
export function useFeature(feature: string): boolean {
  return useAuthStore((s) => s.session?.features?.[feature] === true)
}
